import { gql } from '@apollo/client';


export const GET_VEHICLE_BY_VIN = gql`
  query GET_VEHICLE_BY_VIN($vin: String!, $originatorId: ID!){
    getVehicleByVin(vin: $vin, originatorId: $originatorId) {
      id
      description
      plateType {
        id
        name
      }
      value
      vehicleMake {
        id
        nhtsaId
        name
      }
      vehicleModel {
        id
        nhtsaId
        name
      }
      vehicleVin {
        id
        name
      }
      vehicleColor {
        id
        name
      }
      vehicleState {
        id
        name
      }
      vehiclePlate {
        id
        name
      }
      year
    }
  }
`;


